import { Component, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import {SubmissionSearchUserInfoObject} from './search-object';
import {SubmissionHistoryService} from '../../shared/services/submission-history.service';
import {Router} from '@angular/router';

@Component({
    templateUrl: './admin-root.component.html',
    styleUrls: ['./root.component.scss']
})
export class AdminRootComponent implements OnInit {

    private userInfoSubscription: Subscription;
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();

    constructor(private submissionHistoryService: SubmissionHistoryService,
                public router: Router) {}

    ngOnInit() {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {
            this.userInfo = message
        })
    }

    public isAuthorized(): boolean {
        if (this.userInfo != null && this.userInfo.internalUser) {
            return true;
        } else {
            this.router.navigate(['submissions']);
            return false;
        }
    }
}
